export const ShareLinksAPIType = "share_links" as const
export const SendShareLinksAPIType = "send_share_links" as const
